import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/dialogDrag'
import {Base64} from 'js-base64'

import 'default-passive-events'

import ElementUI from 'element-ui';
import  './assets/font/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';

import * as echarts from 'echarts';
import chatmsg from "./lib/chatMessageDialog";

Vue.use(ElementUI);
Vue.use(Base64);

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$chatmsg = chatmsg.install;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
